import React, { useEffect, useState, forwardRef } from 'react';
import $ from 'jquery';
import DropdownButton from '../bootstrap4/DropdownButton';
import Modal from '../bootstrap4/Modal';
import bootbox from 'bootbox';
import toastr from 'toastr';
import Toastr from 'toastr';
import Loading from '../Loading';
import Input from '../bootstrap4/Input';
import Activity from './Activity';
import AddActivity from './AddActivity';
import DeleteActivity from './DeleteActivity';
import CommonUtils from '../../util/CommonUtils';

let currActivity = null;
function SensorActivities(props, refs) {
    let user = props.user;

    const [loading, setLoading] = useState(null);
    const [sensors, setSensors] = useState([]);
    const [applyActivityTemplates, setApplyActivityTemplates] = useState([]);
    const [sensorActivities, setSensorActivities] = useState(null);
    const [activity, setActivity] = useState(null);
    const [activity_info, setActivityInfo] = useState(null);
    const [activityModified, setActivityModified] = useState(null);
    const [sensor_group_map, setSensorGroupMap] = useState({});

    let activity_id = props.activity_id || '';

    useEffect(() => {
        if (props.activity_id || window.location.href.includes("site-management#sensor-notifications")) {
            fetchSiteLocationSensors();
            fetchSensorActivities();
        }
    }, []);

    useEffect(() => {
        if (activityModified !== null && (activityModified.activity_id + '').includes('SITESUPT')) {
            isActivityModified('from activitymodified');
        }
    }, [activityModified]);

    useEffect(() => {
        if (activity_info !== null) {
            isActivityModified('from activity info');
        }
    }, [activity_info]);

    useEffect(() => {
        if (sensorActivities !== null) {
            onActivitySelected(currActivity);
            setLoading(false);
        }
    }, [sensorActivities]);

    const fetchSiteLocationSensors = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "D",
            criteria: {
                from: 0,
                size: 1000,
                sensor_site_id: user.site_selected.site_id
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    var data = res.data.records;
                    setSensors(data);
                }
            }
        )
    }

    const fetchSensorActivities = () => {
        let groupsFilter = [];
        groupsFilter.push({ attribute: "site_id", value: user.site_selected.site_id, operator: "=", join_by: "or" });
        groupsFilter.push({ attribute: "group_id", value: '0000000000000', operator: "=", join_by: "or" });

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "M",
            criteria: {
                from: 0,
                size: 1000,
                advanced_filter: JSON.stringify(groupsFilter)
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor_group/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records && res.data.records.length > 0) {

                        let groupTemplates = [];
                        let groups = [];

                        res.data.records.map((x) => {
                            if (x.record.group_id === '0000000000000') {
                                groupTemplates.push(x.record);
                            } else {
                                groups.push(x.record);
                            }
                            return true;
                        });

                        for (let group of groupTemplates) {
                            group.group_id = 'SITESUPT';
                            group.activity_name = group.group_name;
                            group.activity_desc = group.group_desc;
                            group.activity_id = '';
                            group.site_id = user.site_selected.site_id;

                            if (Array.isArray(group.group_thresh_json)) {
                                group.activity_thresh_json = group.group_thresh_json
                            }
                        }
                        currActivity = null;
                        let sensorActivity = [];
                        let sensor_group = { 'SITESUPT': '' };
                        for (let group of groups) {
                            group.activity_name = group.group_name;
                            group.activity_desc = group.group_desc;
                            group.activity_id = group.group_id;

                            sensor_group[group.group_id] = group.group_name;

                            if (Array.isArray(group.group_thresh_json)) {
                                group.activity_thresh_json = group.group_thresh_json;
                            }

                            sensorActivity.push(group);
                            if (group.activity_id + '' === activity_id + '') {
                                currActivity = group;
                            }
                        }

                        if (!currActivity && sensorActivity.length > 0) {
                            currActivity = sensorActivity[0];
                        }

                        // console.log('groupTemplates', groupTemplates);
                        // console.log('sensorActivity', sensorActivity);

                        setApplyActivityTemplates(groupTemplates);
                        setSensorGroupMap(sensor_group);
                        setActivityModified(currActivity);
                        setSensorActivities(sensorActivity);
                        setActivity(null);
                        // onActivitySelected(currActivity);
                    }
                } else {
                    setLoading(false);
                }
            });
    }

    const showLoading = (loadingMessage) => {
        setLoading(loadingMessage);
    }

    const onActivityInfoChange = (e) => {
        let target = $(e.target);
        let attribute = target.attr('name');
        let activity_info_new = { ...activity_info };
        activity_info_new[attribute] = target.val();
        let activity = { ...activityModified }
        activity[attribute] = target.val();
        setActivityModified(activity);
        setActivityInfo(activity_info_new);
    }

    const updateSensorGroups = async (group_id) => {
        return new Promise((resolve, reject) => {
            let sensor_s = sensors.filter(s => s.modified);
            sensor_s.forEach(s => {
                if (s.group_id === 'SITESUPT') {
                    s.group_id = group_id;
                }
            });

            if (sensor_s.length === 0) {
                resolve();
                // Toastr.success("Sensor notification settings saved successfully !");
                return;
            }

            let data = {
                form_input: {
                    customer_id: user.site_selected.customer_id,
                    site_id: user.site_selected.site_id,
                    sensor_groups: JSON.stringify(sensor_s)
                },
                customer_id: user.customer_id,
                site_id: user.site_selected.site_id,
                user_login: user.user_login,
                user_token: user.user_token
            }

            $.ajax({
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site-config/update',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }).then((res) => {
                Toastr.success("Sensors info saved successfully !");
                if (res && res.status && res.status.code === 200) {
                    let sensor = [...sensors];
                    sensor.forEach(s => {
                        if (s.modified) { delete s.modified; }
                    });
                    setLoading(false);
                    setSensors(sensor);
                    resolve(sensor);
                } else {
                    Toastr.error("Error occurred. Please try again !");
                }
            })
        })
    }

    const deleteSensorGroups = (group_id) => {
        let sensor = [...sensors];
        sensor.forEach(s => {
            if (s.group_id === group_id) {
                s.group_id = ' ';
                s.modified = true;
            }
        });
        setSensors(sensor);
        updateSensorGroups();
    }

    const updateActivityState = (activity, sensor_Activities = sensorActivities) => {
        if (activity) {
            let activity_info = {};
            for (let k of ['activity_name', 'activity_desc']) // To track activity info separately.
                activity_info[k] = activity[k];

            let activityModify = JSON.parse(JSON.stringify(activity));
            setActivityModified(activityModify);
            setSensorActivities(sensor_Activities);
            setActivity(JSON.parse(JSON.stringify(activity)));
            setActivityInfo(activity_info);

        } else {
            setSensorActivities(sensor_Activities);
            setActivity(null);
            setActivityInfo(null);
        }
    }

    const onActivitySelected = (activitySelected, afterSave = false) => {
        let isSaveBtnEnabled = $('.save_sensor_settings').length > 0 && !$('.save_sensor_settings').attr('disabled');
        if (isSaveBtnEnabled) {
            bootbox.confirm('Would you like to save the changes before you proceed ?', (isYes) => {
                if (isYes) {
                    saveSensorSettings();
                } else {
                    resetActivity();
                }
            });
        } else {
            if (afterSave === true) {
                let found = false;
                for (let activity of sensorActivities) {
                    if (activity.activity_id + '' === activitySelected.activity_id + '') {
                        activity = activitySelected;
                        found = true
                    }
                }
                if (!found) {
                    sensorActivities.push(activitySelected)
                }
            }

            if (activitySelected === null || activitySelected === undefined) {
                if (sensorActivities && sensorActivities.length > 0) {
                    activitySelected = sensorActivities[0];
                } else {
                    return;
                }
            }

            updateActivityState(activitySelected, sensorActivities)
        }
    }

    const confirmBeforeSelectSettings = () => {
        let isSaveBtnEnabled = $('.save_sensor_settings').length > 0 && !$('.save_sensor_settings').attr('disabled');
        if (isSaveBtnEnabled) {

            bootbox.dialog({
                message: "Would you like to save your changes before you proceed to add new ? ",
                buttons: [
                    { callback: () => { $('.add-sensor-settings').trigger('click'); $('.save_sensor_settings').attr('disabled', true); }, label: 'No' },
                    { callback: () => { saveSensorSettings(); }, label: 'Yes' }
                ]
            })
        } else {
            $('.add-sensor-settings').trigger('click');
        }
    }

    const resetActivity = () => {
        activity_id = activity ? activity.activity_id : null;
        setActivity(null);
        setActivityInfo(null);
        fetchSiteLocationSensors();
        fetchSensorActivities();
    }

    const resetSensorSettings = () => {
        bootbox.dialog({
            message: "Are you sure you want to reset the changes ?",
            buttons: [
                { className: 'btn btn-sm btn-default w-50', callback: () => { }, label: 'No' },
                { className: 'btn btn-sm btn-primary w-50', callback: () => { resetActivity(); }, label: 'Yes' }]
        });
    }

    const onConfirmDelete = (activity_id) => {
        let fileName = activity.activity_name;
        var payload = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id,
            form_input: { group_id: activity_id, site_id: user.site_selected.site_id }
        };
        deleteSensorGroups(activity_id);

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor_group/delete',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(payload)
        }).then((res) => {
            if (res.status && res.status.code === 200) {
                fetchSensorActivities();
                showLoading('Deleting ' + fileName + ' ...');
                Toastr.success('Deleted successfully', 'Status');
            }
        })
    }

    const saveSensorSettings = () => {

        var data = { ...activityModified };
        if (activityModified.activity_name === "") {
            return Toastr.error("Activity name should not be empty");
        }

        let activity = sensorActivities.filter((name) => name.activity_id !== activityModified.activity_id);
        let currActivity = activity.find((name) => name.activity_name === activityModified.activity_name);
        if (currActivity) {
            return Toastr.error("Activity name should not be same");
        }

        var commonData = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id
        };

        const thresholdsModified = data.activity_thresh_json;
        for (let threshold of thresholdsModified) {

            if (!threshold.default) {
                if (threshold.inputValidation && !threshold.inputValidation.isvalidtext) {

                    const position = toastr.options.positionClass
                    toastr.options.positionClass = 'toast-top-center';
                    toastr.error(threshold.inputValidation.invaliderrormsg)
                    toastr.options.positionClass = position;
                    return
                }
                else if (threshold.sensor_id && (threshold.sensor_id.toLowerCase().includes("temperature") || threshold.sensor_id.toLowerCase().includes("humidity"))) {
                    if (!(Number(threshold.alert_down) < Number(threshold.alert_up))) {

                        const position = toastr.options.positionClass
                        toastr.options.positionClass = 'toast-top-center';
                        toastr.error(threshold.sensor_id + " : Drops below should be lower than rises above.")
                        toastr.options.positionClass = position;
                        return
                    }
                }
            }
        }

        showLoading('Saving details ...');


        for (let t of data.activity_thresh_json) {
            if (t.alert_timeout) {
                try {
                    t.alert_timeout = parseInt(t.alert_timeout);
                } catch (error) {
                    t.alert_timeout = 180;
                }
            }
            if (t.notify_me) {
                try {
                    t.notify_me = t.notify_me === 'true' || t.notify_me === true ? true : false;
                } catch (error) {
                }
            }

        }

        data.group_thresh_json = data.activity_thresh_json;
        data.site_id = user.site_selected.site_id;
        data.customer_id = user.customer_id;
        data.group_desc = data.activity_desc;
        data.group_name = data.activity_name;

        let group_id_old = data.activity_id + '';
        let operation = "modify";
        if (group_id_old.includes('SITESUPT')) {
            delete data.activity_id;
            operation = "create";
            data.group_id = CommonUtils.generateRandom(1000000000000, 9999999999999) + "";
        }

        let allowedAtts = ['group_id', 'site_id', 'group_desc', 'group_name', 'group_thresh_json'];

        let groupPayload = {};
        for (let k in data)
            if (allowedAtts.includes(k))
                groupPayload[k] = data[k];

        let payload = { ...commonData };
        payload.form_input = groupPayload;

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor_group/' + operation,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(payload)
            }
        ).then(
            async (res) => {
                if (res && res.status && res.status.code === 200) {
                    await updateSensorGroups(data.group_id);

                    if (operation === 'create') {
                        sensor_group_map[data.group_id] = data.activity_name;
                    }

                    data.group_desc = data.activity_desc;
                    data.group_name = data.activity_name;
                    data.activity_id = data.group_id;
                    data.activity_thresh_json = data.group_thresh_json;
                    $('.save_sensor_settings').attr('disabled', true);
                    onActivitySelected(data, true);
                    Toastr.success("Sensor notification settings saved successfully !");

                }

                setLoading(false);
            });
    }

    const isActivityModified = () => {
        function compareJSONObject(O1, O2) {
            var keys1 = Object.keys(O1);
            var keys2 = Object.keys(O2);
            if (keys1.length === keys2.length && JSON.stringify(keys1.sort()) === JSON.stringify(keys2.sort())) {
                for (var k of keys1) {
                    if ($.isPlainObject(O1[k])) {
                        return compareJSONObject(O1[k], O2[k]);
                    } else if (Array.isArray(O1[k])) {
                        return compareJSONArray(O1[k], O2[k], 'sensor_id');
                    } else {
                        if (O1[k] !== O2[k]) {
                            return false;
                        }
                    }
                }
            } else {
                return false;
            }
            return true;
        }

        function compareJSONArray(O1, O2, key) {
            if (O1.length === O2.length) {
                let O1New = O1.sort((x, y) => { return x[key] - y[key] });
                let O2New = O2.sort((x, y) => { return x[key] - y[key] });
                for (var k in O1New) {
                    let result = compareJSONObject(O1New[k], O2New[k]);
                    if (!result)
                        return result;
                }
            } else {
                return false;
            }
            return true;
        }

        let isModified = false;
        if (activity && activityModified) {
            let a = JSON.parse(JSON.stringify(activity));
            let b = JSON.parse(JSON.stringify(activityModified));
            let isNotModified = compareJSONObject(a, b);
            if (isNotModified && (activityModified.activity_id + '').includes('SITESUPT')) {
                isModified = true;
            } else {
                isModified = !isNotModified;
            }

            if (!isModified) {
                if (sensors && sensors.length > 0) {
                    isModified = sensors.find(s => s.modified === true) !== undefined;
                }
            }
        }

        toggleButtons(isModified);
        return isModified;
    }

    const toggleButtons = (isModified) => {
        if (isModified) {
            $('.save_sensor_settings').attr('disabled', false);
            $('.reset_sensor_settings').attr('disabled', false);
            $('.save_sensor_settings').off('click').on('click', saveSensorSettings);
            $('.reset_sensor_settings').off('click').on('click', resetSensorSettings);
        } else {
            $('.reset_sensor_settings').attr('disabled', true);
            $('.save_sensor_settings').attr('disabled', true);
        }
    }

    const toggleSelection = (sensor_serial_number) => {
        let sensor = [...sensors];
        for (let s of sensor) {
            if (s.sensor_serial_number === sensor_serial_number) {

                let hasProp = s.hasOwnProperty('group_id');
                if (hasProp && !Object.keys(sensor_group_map).includes(s.group_id))
                    s.group_id = ' ';

                s.group_id = (!hasProp || (s.group_id === ' ')) ? activity.group_id : ' ';

                if (s.hasOwnProperty('modified'))
                    delete s.modified;
                else
                    s.modified = true;

                break;
            }
        }
        setSensors(sensor);
    }

    useEffect(() => {
        if (sensors) {
            isActivityModified();
        }
    }, [sensors]);

    const getClassName = (s, other = false) => {
        let activity_id = activity.activity_id;
        return "fa fa-lg text-primary " + (other ? "fa-check-square disabled-checkbox text-warning" : s.group_id === activity_id ? "fa-check-square" : "far fa-square");
    }

    const onThresholdChange = (thresholdModified) => {
        let thresholds = JSON.parse(JSON.stringify(activityModified.activity_thresh_json));

        for (const activity of thresholds) {
            if (activity.sensor_id === thresholdModified.sensor_id) {
                if (!activity.fieldName) {
                    if (thresholdModified.fieldName)
                        delete thresholdModified.fieldName
                }
            }
        }
        let i = 0;
        for (let threshold of thresholds) {
            if (thresholdModified.sensor_id === threshold.sensor_id) {
                let thresholdModifiedCopy = { ...thresholdModified };
                if (thresholdModifiedCopy.default) {
                    thresholdModifiedCopy.default = true;
                    thresholds[i] = thresholdModifiedCopy;
                } else {
                    thresholds[i] = thresholdModifiedCopy;
                }
            }
            i++;
        }
        activityModified.activity_thresh_json = thresholds;
        isActivityModified();
    }

    // const getSensorTooltip = (group_id) => {
    //     console.log('group_id', group_id);
    //     let sensorGroup = sensorActivities && sensorActivities.find((s) => s.activity_id + '' === group_id + '');
    //     console.log('sensorGroup', sensorGroup);
    //     return sensorGroup ? sensorGroup.activity_name : null;
    // }
    React.useImperativeHandle(refs, () => ({
        showLoading,
        isActivityModified,
        fetchSensorActivities,
        fetchSiteLocationSensors,
        saveSensorSettings
    }));

    let deleteButtonCSS = (activity && activity.activity_id && (activity.activity_id + '').includes('SITESUPT')) ? 'hide' : 'btn btn-sm btn-danger btn-border-1 mr-2';
    let sensor_group_ids = Object.keys(sensor_group_map);
    let curr_group_id = activity ? String(activity.group_id) : 'SITESUPT';
    let sensors_other = sensors && sensors.filter((s) => (s.hasOwnProperty('group_id') && sensor_group_ids.includes(s.group_id) && s.group_id !== curr_group_id));
    let sensors_left = sensors && sensors.filter((s) => (!s.hasOwnProperty('group_id') || !sensor_group_ids.includes(s.group_id) || s.group_id === ' ' || s.group_id === curr_group_id));

    let hasRSCOSensor = sensors_left.length > 0 && sensors_left.find(s => s.group_id === curr_group_id && s.sensor_type === 'RSCO') !== undefined;
    let sensorsOfCurrGroup = sensors_left.length > 0 && sensors_left.filter(s => s.group_id === curr_group_id);
    setTimeout(() => { $('[data-toggle="tooltip"]').tooltip(); }, 5000);
    return (
        <React.Fragment>
            {loading && <Loading>{loading}</Loading>}
            {!loading && sensorActivities &&
                <div className='row mb-4'>
                    <div className='col-md-6'>
                        {sensorActivities.length > 0 ?
                            <React.Fragment>
                                <label className='pr-2'>Select To Edit :</label>
                                <DropdownButton
                                    className='btn btn-sm dropdown-toggle text-dark'
                                    onOptionClick={onActivitySelected}
                                    default={activity ? activity.activity_name : 'Choose Zone Setting'}
                                    selected={activity ? activity.activity_id : ''}
                                    opts={sensorActivities}
                                    field_attr='activity_id'
                                    value_attr='activity_name'
                                />
                            </React.Fragment>
                            :
                            activity ? '' : <span className='text-app'><i className="fa fa-warning text-warning"></i> No Sensor Settings found ...</span>
                        }
                    </div>
                    <div className="col-md-6 text-md-right">
                        {!loading &&
                            <span>
                                <button className='btn btn-sm btn-success btn-border-1 mr-2' data-toggle='tooltip' onClick={confirmBeforeSelectSettings}>Add</button>
                                <Modal title="Select Settings Template" id="selectSensorsModal" label={<button className="btn hide btn-sm btn-primary btn-border-1 ml-2 add-sensor-settings" data-toggle="tooltip"><i className="fa fa-plus"></i></button>} size="modal-md">
                                    <AddActivity title="Select Settings Template" activityTemplates={applyActivityTemplates} onActivitySelected={onActivitySelected} />
                                </Modal>
                            </span>
                        }
                        {activity &&
                            <span>
                                {/* <button className='btn btn-sm btn-success btn-border-1 mr-2' data-toggle='tooltip' onClick={this.confirmBeforeSelectSettings}>Add</button>
                                    <Modal title="Select Settings Template" id="selectSensorsModal" label={<button className="btn hide btn-sm btn-primary btn-border-1 ml-2 add-sensor-settings" data-toggle="tooltip"><i className="fa fa-plus"></i></button>} size="modal-md">
                                        <AddActivity  title="Select Settings Template" activityTemplates={this.state.applyActivityTemplates} onActivitySelected={this.onActivitySelected} />
                                    </Modal> */}
                                <button className='btn btn-sm btn-light btn-border-1 mr-2 reset_sensor_settings' onClick={resetSensorSettings} disabled={true}>Cancel</button>

                                <Modal title="Confirmation" id="deleteSensorsModal" label={<button className={deleteButtonCSS}> Delete</button>} size="modal-md">
                                    <DeleteActivity title="Confirmation" onConfirmDelete={onConfirmDelete} activity={activity} />
                                </Modal>

                                <button className="btn btn-sm btn-primary btn-border-1 save_sensor_settings" disabled={true} onClick={() => saveSensorSettings()}>Save</button>
                            </span>
                        }
                    </div>
                </div>
            }
            {!loading && activity && activity_info &&
                <React.Fragment>
                    <div className="card border border-0 bg-light border-light">
                        <div className='card-header p-0'>
                            <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                                {activity_info.activity_name}
                            </div>
                        </div>
                        <div className="card-body bg-white border-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td width="100px"><label>Name : </label></td><td><Input type="text_no_regex" name="activity_name" maxLength="45" className="form-control width-100-perc" value={activity_info.activity_name} onChange={onActivityInfoChange}></Input></td>
                                            </tr>
                                            <tr>
                                                <td width="100px"><label>Description : </label></td><td><textarea type="text" name="activity_desc" maxLength="1024" className="form-control width-100-perc" value={activity_info.activity_desc} onChange={onActivityInfoChange}></textarea></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" className="pb-2 pt-5">
                                                    <div className="my-1">Sensors grouped in other templates :</div>
                                                    <div className="row">
                                                        {
                                                            sensors_other.sort((a, b) => a.sensor_serial_number > b.sensor_serial_number ? 1 : b.sensor_serial_number > a.sensor_serial_number ? -1 : 0).map((s, i) => (
                                                                <div key={'sensors_other_' + i} className="col-xs-6 col-sm-6 col-md-2 col-lg-2" data-original-title={sensor_group_map[s.group_id]} data-toggle="tooltip" title={sensor_group_map[s.group_id]}>
                                                                    <div role="group" className="py-1 border-rounded-b">
                                                                        <span className="p-2"><i className={getClassName(s, true)}></i></span>
                                                                        <span className="mt-1 font-size-12">{s.sensor_name && s.sensor_name.trim() ? s.sensor_name : s.sensor_serial_number}</span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan="2" className="py-2">
                                                    <div className="my-1">Sensors available to select/modify:</div>
                                                    <div className="row">
                                                        {sensors_left.length === 0 ? <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 text-warning">No sensors available</div> :
                                                            sensors_left.sort((a, b) => a.sensor_serial_number > b.sensor_serial_number ? 1 : b.sensor_serial_number > a.sensor_serial_number ? -1 : 0).map((s, i) => (
                                                                <div key={'sensors_left_' + i} className="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                                                                    <div role="group" className="py-1 border-rounded-b" onClick={() => toggleSelection(s.sensor_serial_number)} >
                                                                        <span className="p-2"><i className={getClassName(s)}></i></span>
                                                                        <span className="mt-1 font-size-12">{s.sensor_name && s.sensor_name.trim() ? s.sensor_name : s.sensor_serial_number}</span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer bg-white border-0 p-1">
                            <span className="px-2 text-procore pt-5">Sensors Specific Alerts:</span>
                            <div className="pt-2">
                                <div className="row"><div className="col-md-12 p-2"><span className="ml-3"><i className="fa fa-info-circle text-primary"></i> <span className="font-size-12"><i>Default Alert Notification: Every 3 hours.</i></span></span></div></div>
                                <Activity activity={activity} onChange={onThresholdChange} refresh_id={new Date().getUTCMilliseconds()} showRSCOthreshold={hasRSCOSensor} sensors={sensorsOfCurrGroup}></Activity>
                            </div>
                        </div>
                    </div>

                </React.Fragment>}
        </React.Fragment>
    );

}

export default forwardRef(SensorActivities);